import { render, staticRenderFns } from "./trash_icon_alt.vue?vue&type=template&id=5ac68a70&"
import script from "./trash_icon_alt.vue?vue&type=script&lang=ts&"
export * from "./trash_icon_alt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports